import React from "react";
import LoginTemplate from "../components/templates/LoginTemplate";

const Login = () => {
    return(
        <LoginTemplate/>
    )
};

export default Login;